import Spinner from './Spinner/Spinner'
import Error from './Error/Error'
import { keycloakInitOptions } from '../keycloak'



export const Home = () => {
  const keycloakOptions = keycloakInitOptions()
  const isNotAllowed = JSON.stringify(keycloakOptions) === "{}"

  return isNotAllowed ?  <Error /> :  <Spinner size={60} />
}